import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { toastReducer } from '../ui/toast-store.js';
import { apiSlice } from './api-slice.js';

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    toasts: toastReducer,
  },
  middleware: (getDefault) => getDefault().concat(apiSlice.middleware),
});

// Enables refetchOnReconnect / refetchOnFocus behaviour.
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
